let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("agCe5")).then(() => parcelRequire('18HMn'));